import {
  EMPTY_FIELD_MESSAGE,
  validateSpace,
  validateTextEn,
  validateUrl,
} from '@Utils/validation';
import { SubcommitteeType } from 'src/Enum/EsgGreenhouse';
import { z } from 'zod';

enum SUBCOMMITTEES_MODAl_FORM_MESSAGE {
  TYPE = 'กรุณาระบุขอบเขตการปล่อยก๊าซเรือนกระจก',
  NAME_TYPE = 'กรุณาระบุชื่อคณะกรรมการชุดย่อย',
  NAME_TYPE_EN = 'กรุณาระบุชื่อคณะกรรมการชุดย่อยเป็นภาษาอังกฤษ',
  OTHERS = 'กรุณาระบุอื่น ๆ',
  OTHERS_EN = 'กรุณาระบุอื่น ๆ เป็นภาษาอังกฤษ',
  EMPTY_OTHERS = 'กรุณาระบุอื่น ๆ (ภาษาไทย)',
  EMPTY_OTHERS_EN = 'กรุณาระบุอื่น ๆ (ภาษาอังกฤษ)',
  IS_URL = 'กรุณาระบุลิงก์กฎบัตรตามชื่อคณะกรรมการชุดย่อยที่ระบุข้างต้นเป็นลิงก์',
  RESPONSIBILITIES = 'กรุณาระบุขอบเขต อำนาจ หน้าที่ และบทบาทความรับผิดชอบ',
  RESPONSIBILITIES_EN = 'กรุณาระบุขอบเขต อำนาจ หน้าที่ และบทบาทความรับผิดชอบ เป็นภาษาอังกฤษ',
}

const OtherSubcommitteeRoleSchema = z.object({
  nameTh: z
    .string()
    .min(1, SUBCOMMITTEES_MODAl_FORM_MESSAGE.OTHERS)
    .nullish()
    .or(z.literal(''))
    .optional(),
  nameEn: z
    .string()
    .min(1, SUBCOMMITTEES_MODAl_FORM_MESSAGE.OTHERS)
    .regex(validateTextEn, SUBCOMMITTEES_MODAl_FORM_MESSAGE.OTHERS_EN)
    .nullish()
    .or(z.literal(''))
    .optional(),
});

export const modalAddSubCommitteesValidationSchema = z
  .object({
    nameTh: z
      .string({ message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.NAME_TYPE })
      .optional(),
    nameEn: z
      .string()
      .min(1, { message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.NAME_TYPE })
      .regex(validateTextEn, {
        message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.NAME_TYPE_EN,
      })
      .optional(),
    subcommitteeType: z.string().min(1),
    subcommitteeRoles: z.array(z.any()).min(1),
    otherSubcommitteeRoles: z
      .array(OtherSubcommitteeRoleSchema)
      .nullable()
      .optional(),
    responsibilitiesTh: z
      .string()
      .min(1, { message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.RESPONSIBILITIES })
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
    responsibilitiesEn: z
      .string()
      .min(1, { message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.RESPONSIBILITIES })
      .regex(validateTextEn, {
        message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.RESPONSIBILITIES_EN,
      })
      .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
    charterUrlTh: z
      .string()
      .regex(validateUrl, SUBCOMMITTEES_MODAl_FORM_MESSAGE.IS_URL)
      .or(z.literal(''))
      .nullable()
      .optional(),
    charterUrlEn: z
      .string()
      .regex(validateUrl, SUBCOMMITTEES_MODAl_FORM_MESSAGE.IS_URL)
      .or(z.literal(''))
      .nullable()
      .optional(),
    charterPageTh: z.string().nullable().optional(),
    charterPageEn: z.string().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.subcommitteeType === SubcommitteeType.OTHER_SUBCOMMITTEE) {
      if (!data.nameTh || data.nameTh.trim() === '') {
        ctx.addIssue({
          code: 'custom',
          path: ['nameTh'],
          message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.NAME_TYPE,
        });
      }

      if (!data.nameEn || data.nameEn.trim() === '') {
        ctx.addIssue({
          code: 'custom',
          path: ['nameEn'],
          message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.NAME_TYPE,
        });
      }
    }

    if (
      data.otherSubcommitteeRoles &&
      Array.isArray(data.otherSubcommitteeRoles) &&
      data.otherSubcommitteeRoles.length > 0
    ) {
      data.otherSubcommitteeRoles.forEach((role, index) => {
        if (
          role.nameTh &&
          role.nameTh.trim() !== '' &&
          (!role.nameEn || role.nameEn?.trim() === '')
        ) {
          ctx.addIssue({
            code: 'custom',
            path: [`otherSubcommitteeRoles.${index}.nameEn`],
            message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.EMPTY_OTHERS_EN,
          });
        }

        if (
          role.nameEn &&
          role.nameEn.trim() !== '' &&
          (!role.nameTh || role.nameTh?.trim() === '')
        ) {
          ctx.addIssue({
            code: 'custom',
            path: [`otherSubcommitteeRoles.${index}.nameTh`],
            message: SUBCOMMITTEES_MODAl_FORM_MESSAGE.EMPTY_OTHERS,
          });
        }
      });
    }
  });
